export enum MatchType {
  All = 0,
  Matchmaking = 1,
  Custom = 2,
  Local = 3,
}
